import Phaser from 'phaser';
import { language } from './language';
import { CST } from '../CST';
import config from '../helpers/config';

var clickSound;
let count = 0;

export default class Rules extends Phaser.Scene {
	constructor() {
		super(CST.SCENES.RULES1);
	}

	preload() {
		this.load.image('rules1', 'assets/english/Rules1.png');
		this.load.image('back_btn', 'assets/english/go-backwards.png');
		this.load.image('close_btn', 'assets/english/close.png');
		this.load.image('next_btn', 'assets/english/go-forward.png');
		this.load.image('btn-video', 'assets/english/btn-video.png');
	}

	create(data) {
		clickSound = this.sound.add('clickSound');
		this.chatChannel = new BroadcastChannel('chat_channel');

		this.scene.bringToTop();

		this.bg = this.add.image(
			this.cameras.main.width / 2,
			this.cameras.main.height / 2,
			'rules1' + language,
		);

		if (!config.isViewOnly) {
			// X = -690 Y = -425
			this.backBtn = this.add
				.image(
					this.cameras.main.width / 2 - 160,
					this.cameras.main.height / 2 + 420,
					'back_btn' + language,
				)
				.setScale(1.2)
				.setInteractive({
					useHandCursor: true,
				})
				.on('pointerdown', () => {
					count--;
					this.rulesPage(count);
					this.chatChannel.postMessage(JSON.stringify({ action: 'prev-page' }));
				})
				.setVisible(false);

			//X = +690 Y = -425
			// this.nextBtn = this.add
			// 	.image(
			// 		this.cameras.main.width / 2 + 160,
			// 		this.cameras.main.height / 2 + 420,
			// 		'next_btn' + language,
			// 	)
			// 	.setScale(1.2)
			// 	.setInteractive({
			// 		useHandCursor: true,
			// 	})
			// 	.on('pointerdown', () => {
			// 		count++;
			// 		this.rulesPage(count);
			// 		this.chatChannel.postMessage(JSON.stringify({ action: 'next-page' }));
			// 	});

			this.closeBtn = this.add
				.image(
					this.cameras.main.width / 2,
					this.cameras.main.height / 2 + 405,
					'close_btn' + language,
				)
				.setScale(1.2)
				.setInteractive({
					useHandCursor: true,
				})
				.on('pointerdown', () => {
					clickSound.play();
					count = 0;
					this.scene.stop();
					this.scene.resume(data.scene, { data: 5 });
					this.chatChannel.postMessage(JSON.stringify({ action: 'close-rules' }));
				});

			this.videoBtn = this.add
				.image(260, this.cameras.main.height / 2 + 405, 'btn-video')
				.setScale(0.9)
				.setInteractive({ useHandCursor: true })
				.on('pointerdown', () => {
					clickSound.play();
					this.videoBtn.disableInteractive();
					if (this.cache.video.has('rules-video')) {
						this.showVideo();
					} else {
						this.load.video(
							'rules-video',
							'assets/english/Video/how-to-use-leadership-team-roulette-web.mp4',
						);
						this.load.once('complete', () => this.showVideo());
						this.load.start();
					}
				});

			if (/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
				this.backBtn.x = this.cameras.main.width / 2 - 330;
				// this.nextBtn.x = this.cameras.main.width / 2 + 330;
				this.closeBtn.x = this.cameras.main.width / 2 - 650;
				this.closeBtn.y = this.cameras.main.height / 2 - 410;
			}
		} else {
			this.chatChannel.onmessage = event => {
				const data = JSON.parse(event.data);

				switch (data.action) {
					case 'prev-page':
						count--;
						this.rulesPage(count);
						break;
					case 'next-page':
						count++;
						this.rulesPage(count);
						break;
					case 'close-rules':
						count = 0;
						this.scene.stop();
						this.scene.resume(data.scene, { data: 5 });
						break;

					default:
						break;
				}
			};
		}
	}

	showVideo() {
		const cx = this.cameras.main.width / 2;
		const cy = this.cameras.main.height / 2;

		this.videoOverlay = this.add
			.rectangle(cx, cy, this.cameras.main.width, this.cameras.main.height, 0x000000, 1)
			.setDepth(10);

		this.activeVideo = this.add
			.video(cx, cy, 'rules-video')
			.setDepth(11)
			.setDisplaySize(1500, 929)
			.setScale(1.028);

		this.activeVideo.play();

		this.videoCloseBtn = this.add
			.image(cx + 645, cy - 415, 'close_btn')
			.setDepth(12)
			.setScale(1.2)
			.setInteractive({ useHandCursor: true })
			.on('pointerdown', () => {
				clickSound.play();
				this.closeVideo();
			});

		this.activeVideo.once('complete', () => this.closeVideo());
	}

	closeVideo() {
		if (this.activeVideo) {
			this.activeVideo.stop();
			this.activeVideo.destroy();
			this.activeVideo = null;
		}
		if (this.videoOverlay) {
			this.videoOverlay.destroy();
			this.videoOverlay = null;
		}
		if (this.videoCloseBtn) {
			this.videoCloseBtn.destroy();
			this.videoCloseBtn = null;
		}
		this.videoBtn.setInteractive({ useHandCursor: true });
	}

	rulesPage(count) {
		clickSound.play();
		switch (count) {
			case 0:
				this.bg.setTexture('rules1' + language);
				this.backBtn.disableInteractive().setVisible(false);
				this.nextBtn.setInteractive().setVisible(true);
				break;
			case 1:
				this.bg.setTexture('rules2' + language);
				this.backBtn.setInteractive().setVisible(true);
				this.nextBtn.disableInteractive().setVisible(false);
				break;
			// case 2:
			//   this.bg.setTexture("rules3" + language);
			//   this.nextBtn.setInteractive().setVisible(true);
			//   break;
			// case 3:
			//   this.bg.setTexture("rules4" + language);
			//   this.nextBtn.disableInteractive().setVisible(false);
			//   break;
		}
	}
}

